var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/TakePhoto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.538 5l-.24.305L7.385 6.5H2V20h20V6.5h-5.385l-.913-1.195-.24-.305H8.538zm.77 1.5h5.384l.914 1.195.24.305h4.616v10.5H3.538V8h4.616l.24-.305.914-1.195zM5.846 8.75a.761.761 0 0 0-.77.75c0 .413.346.75.77.75.424 0 .77-.337.77-.75a.761.761 0 0 0-.77-.75zm6.154 0c-2.54 0-4.615 2.024-4.615 4.5s2.076 4.5 4.615 4.5c2.54 0 4.615-2.024 4.615-4.5S14.54 8.75 12 8.75zm0 1.5c1.71 0 3.077 1.333 3.077 3s-1.367 3-3.077 3-3.077-1.333-3.077-3 1.367-3 3.077-3z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c085e2b59a49d321fd2a86aafd5c781d.svg";
export { ForwardRef as ReactComponent };